import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormDataUpload, NestApiProvider } from '../../nest-api';
import {
  RequestFindByEmail,
  RequestGetEmpDto,
  RequestInviteMember,
  RequestNewEmployeeDto,
  ResponseEmployeesDto,
  ResponseFindByEmail,
  ResponseNewEmployeeDto,
  ResponseSearchDto,
  UploadEmployeeInviteMemberData,
  RequestGetEmpByAuthDto,
  RequestPagingEmpList,
  RequestEmpList,
} from '../dto/employees.dto';
import { ResponseData, ResponsePaging } from '../../nest-responses';

@Injectable()
export class EmployeesApi {

  private readonly service: string = '';
  private readonly model: string = 'employees';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public get(limit: string | number, page: string | number): Observable<ResponseEmployeesDto> {
    const method: string = 'GET';
    const func: string = '';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEmployeesDto>(method, url, func, params, body);
  }

  public search(limit: string | number, page: string | number, q: string): Observable<ResponseSearchDto> {
    const method: string = 'GET';
    const func: string = 'search';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof q !== 'undefined' && q !== null) urlParams.q = q;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSearchDto>(method, url, func, params, body);
  }

  newEmployee(data: RequestNewEmployeeDto): Observable<ResponseNewEmployeeDto> {
    const method: string = 'POST';
    const func: string = 'newEmployee';
    const params: RequestNewEmployeeDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseNewEmployeeDto>(method, url, params, urlParams, body);
  }

  getEmp(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    if (payload.active === '' || payload.active === null) {
      payload.active = '1'
    }
    const params: RequestGetEmpDto = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  uploadEmployeeInviteMember(file: File, fileName: string): Observable<ResponseData<UploadEmployeeInviteMemberData>> {
    const method: string = 'POST';
    const func: string = 'uploadEmployeeInviteMember';
    const params: FormDataUpload[] = [];
    params.push({ name: 'file', value: file, fileName });
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload<ResponseData<UploadEmployeeInviteMemberData>>(method, url, params);
  }

  public inviteMember(payload: RequestInviteMember): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'inviteMember';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public empList(queryParams: RequestPagingEmpList, payload: RequestEmpList) {
    const method: string = 'POST';
    const func: string = 'empList';
    const params: any = payload || {};
    const urlParams: any =  queryParams || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<any>>(method, url, params, urlParams, body);
  }

  public downloadTemplate(): Observable<Blob> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, func, params, body);
  }

  public findOne(payload: RequestFindByEmail): Observable<ResponseData<ResponseFindByEmail>> {
    const method: string = 'GET';
    const func: string = 'findOne';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseFindByEmail>>(method, url, params, urlParams, body);
  }

  getEmpByAuth(payload: RequestGetEmpByAuthDto, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'getEmpByAuth';
    const params: RequestGetEmpByAuthDto = Object.assign({
      dataAuth: true,
      accessCode: [],
      paging: true,
      userId: null,
      empId: null,
      flag: null,
      gender: null,
      fullName: null,
      active: '1',
      accessCodes: [],
      positionId: [],
      worklocationName: null,
      costcenterName: null,
      gradeName: null,
      notEmpIds: [],
      shiftgroupCode: null,
    }, payload);

    const urlParams: any = queryParams
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  searchPosition(queryParams: { page: number, limit: number }): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'searchPosition';
    const params: any = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/employees.api.ts